module.exports = __webpack_public_path__ + "static/img/16.c8a47ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/16.png
// module id = 3fO0
// module chunks = 0